import { useProgressToast } from '@/components/elements/toast'
import { useRef } from 'react'

export function useImageUploadToast() {
	const progressToast = useProgressToast()
	const toastActiveRef = useRef(false)
	const hasCompletedRef = useRef(false)

	const handleProgress = (
		progress: number,
		isLoading: boolean,
		hasFailed = false
	) => {
		const roundedProgress = Math.round(progress)

		if (isLoading && roundedProgress === 0 && !toastActiveRef.current) {
			progressToast.startProgress({
				message: 'Subiendo imagen',
				duration: 0,
			})
			toastActiveRef.current = true
			hasCompletedRef.current = false
		}

		if (
			isLoading &&
			roundedProgress > 0 &&
			roundedProgress < 100 &&
			toastActiveRef.current
		) {
			progressToast.updateProgress(roundedProgress, {
				message: `Subiendo imagen (${roundedProgress}%)`,
			})
		}

		if (
			roundedProgress >= 100 &&
			toastActiveRef.current &&
			!hasCompletedRef.current
		) {
			hasCompletedRef.current = true
			progressToast.complete({
				message: 'Imagen subida correctamente',
				duration: 3000,
			})
			toastActiveRef.current = false
		}

		if (!isLoading && roundedProgress < 100 && toastActiveRef.current) {
			if (hasFailed) {
				progressToast.dismiss()
			} else {
				progressToast.complete({
					message: 'Imagen subida correctamente',
					duration: 3000,
				})
			}
			toastActiveRef.current = false
		}
	}

	return { handleProgress }
}
